const DATE_FIELDS = new Set(['due_date']);
const SELECT_FIELDS = new Set(['author_id', 'assignee_id', 'responsible_user_id']);

const normalizeSelectValue = (value) => {
  if (value && typeof value === 'object' && 'value' in value) {
    return value.value;
  }
  return value ?? null;
};

const normalizeField = (key, value) => {
  if (SELECT_FIELDS.has(key)) return normalizeSelectValue(value);
  if (DATE_FIELDS.has(key)) return value?.format('YYYY-MM-DD') ?? null;
  return value ?? null;
};

const appendAttachments = (formData, attachments) => {
  const filesToDelete = attachments.filter((f) => f.id && f.markedForDelete);
  const newFiles = attachments.filter((f) => !f.id);

  for (const [index, file] of filesToDelete.entries()) {
    const prefix = `ticket[ticket_attachments_attributes][${index}]`;
    formData.append(`${prefix}[id]`, file.id);
    formData.append(`${prefix}[_destroy]`, '1');
  }

  const offset = filesToDelete.length;

  for (const [index, file] of newFiles.entries()) {
    const prefix = `ticket[ticket_attachments_attributes][${offset + index}]`;
    formData.append(`${prefix}[document]`, file.originFileObj ?? file);
    formData.append(`${prefix}[name]`, file.name);
  }
};

const buildFormParams = ({ form, attachments = [], extraParams = {} }) => {
  const rawValues = form.getFieldsValue();
  const formData = new FormData();

  for (const [key, value] of Object.entries(rawValues)) {
    const normalized = normalizeField(key, value);
    if (normalized !== null && normalized !== undefined) {
      formData.set(`ticket[${key}]`, normalized);
    }
  }

  for (const [key, value] of Object.entries(extraParams)) {
    if (value !== null && value !== undefined) {
      formData.set(key, value);
    }
  }

  appendAttachments(formData, attachments);

  return formData;
};

export default buildFormParams;
